import { type CustomTooltipProps } from "ag-grid-react"

import { StorageLocationTable } from "~/components/inventory/StorageLocationCard"
import { Card, CardContent, CardHeader, CardTitle } from "~/components/reusable/Card"

import HeaderTooltip from "./HeaderTooltip"
import { type IVariantSummary } from "~/hooks/useVariantTableData"

export default function StorageLocationTooltip(props: CustomTooltipProps<IVariantSummary[]>) {
  if (props.location === "header") {
    return <HeaderTooltip {...props} />
  }

  const variants = props.node?.group ? props.value.variants : [props.data]
  const showTooltip = props.value.storageLocationData

  if (showTooltip) {
    return (
      <div className="bg-base mr-6 z-500">
        <Card className="w-full">
          <CardHeader>
            <CardTitle>Storage location</CardTitle>
          </CardHeader>
          <CardContent>
            <StorageLocationTable variants={variants} />
          </CardContent>
        </Card>
      </div>
    )
  }
}
